export const FPS = 30;
export const DURATION_IN_FRAMES = 900;
export const COMPOSITION_WIDTH = 1920;
export const COMPOSITION_HEIGHT = 1080;

// Height of the scroll container driving the playhead. Taller = slower scrub.
export const SCROLL_HEIGHT_VH = 1400;
export const SCROLL_HEIGHT_VH_MOBILE = 900;

export type SceneName =
  | "boot"
  | "map"
  | "zip"
  | "paloDeck"
  | "fourMation"
  | "seniorEra"
  | "constellation"
  | "contact";

export type SceneRange = { from: number; duration: number };

// Frame ranges follow the scroll allocation in IMPLEMENTATION_PLAN.md:
// boot 0–5%, map 5–12%, zip 12–22%, paloDeck 22–45%, fourMation 45–60%,
// seniorEra 60–88%, constellation 88–95%, contact 95–100%.
export const SCENES: Record<SceneName, SceneRange> = {
  boot: { from: 0, duration: 45 },
  map: { from: 45, duration: 65 },
  zip: { from: 110, duration: 90 },
  paloDeck: { from: 200, duration: 205 },
  fourMation: { from: 405, duration: 135 },
  seniorEra: { from: 540, duration: 250 },
  constellation: { from: 790, duration: 65 },
  contact: { from: 855, duration: 45 },
};

export const sceneEnd = (name: SceneName): number =>
  SCENES[name].from + SCENES[name].duration;

// Progress (0–1) equivalents, used by the DOM overlay to sync with scroll.
export const sceneProgressRange = (name: SceneName): [number, number] => [
  SCENES[name].from / DURATION_IN_FRAMES,
  sceneEnd(name) / DURATION_IN_FRAMES,
];

// Beat starts inside the Palo deck scene — one beat per card.
export const PALO_DECK_CARD_IDS = [
  "bookingsg",
  "firstrescue",
  "hsbc",
  "blocktrust",
  "whattruck",
];
export const PALO_BEAT_LENGTH = Math.floor(
  SCENES.paloDeck.duration / PALO_DECK_CARD_IDS.length
);

// Senior-era beats (absolute frames), per the plan's scroll percentages.
export const SENIOR_BEATS = {
  intro: { from: 540, duration: 27 }, // 60–63%
  vista: { from: 567, duration: 63 }, // 63–70%
  imed: { from: 630, duration: 36 }, // 70–74%
  applus: { from: 666, duration: 36 }, // 74–78%
  urbnsurf: { from: 702, duration: 54 }, // 78–84%
  virginactive: { from: 756, duration: 27 }, // 84–87%
  outro: { from: 783, duration: 7 }, // 87–88%
};
